/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IDobbiesBrowseData } from './dobbies-browse.data';
import { IDobbiesBrowseProps } from './dobbies-browse.props.autogenerated';
import MsDyn365 from '@msdyn365-commerce/core';
export interface IDobbiesBrowseViewProps extends IDobbiesBrowseProps<IDobbiesBrowseData> {
    maxNumberOfCategoriesForScreenSize?: number;
}
export interface IDobbiesBrowseState {
    maxNumberOfCategoriesForScreenSize: number;
}

/**
 *
 * DobbiesBrowse component
 * @extends {React.PureComponent<IDobbiesBrowseProps<IDobbiesBrowseData>>}
 */
class DobbiesBrowse extends React.PureComponent<IDobbiesBrowseProps<IDobbiesBrowseData>, IDobbiesBrowseState> {
    public constructor(props: IDobbiesBrowseProps<IDobbiesBrowseData>) {
        super(props);
        this.state = {
            maxNumberOfCategoriesForScreenSize: -1
        };
    }
    public componentDidMount(): void {
        if (MsDyn365.isBrowser) {
            window.addEventListener('resize', this.setMaxCats);
        }
        this.setMaxCats();
    }
    private setMaxCats = (): void => {
        const maxCats = this.getMaxCategoriesForCurrentScreenSize();
        this.setState({ maxNumberOfCategoriesForScreenSize: maxCats });
    };
    private getMaxCategoriesForCurrentScreenSize = () => {
        if ((MsDyn365.isBrowser && window) !== undefined && MsDyn365.isBrowser && window && window.innerWidth) {
            if (window.innerWidth >= 1700) {
                return 4;
            } else if (window.innerWidth >= 1250 && window.innerWidth < 1700) {
                return 3;
            } else if (window.innerWidth >= 700 && window.innerWidth < 1250) {
                return 2;
            } else if (window.innerWidth < 700) {
                return 1;
            }
        }
        return -1;
    };
    public render(): JSX.Element | null {
        const dobbiesBrowseProps = {
            ...this.props,
            maxNumberOfCategoriesForScreenSize: this.state.maxNumberOfCategoriesForScreenSize
        };
        return this.props.renderView(dobbiesBrowseProps);
    }
}

export default DobbiesBrowse;
